import { createResource } from 'react-resource-router';
import { eocCommonResources } from '@atlassian/eoc-resources';
import { getMaintenance, getMaintenanceUserRights } from '../endpoints';
export const maintenanceResource = createResource({
  type: 'maintenanceResource',
  getKey: routerContext => {
    var _routerContext$match$;
    const teamId = (_routerContext$match$ = routerContext.match.params) === null || _routerContext$match$ === void 0 ? void 0 : _routerContext$match$.teamId;
    return `maintenance/${teamId !== null && teamId !== void 0 ? teamId : ''}`;
  },
  getData: async routerContext => {
    var _routerContext$match$2;
    const teamId = (_routerContext$match$2 = routerContext.match.params) === null || _routerContext$match$2 === void 0 ? void 0 : _routerContext$match$2.teamId;
    return getMaintenance(teamId);
  },
  isBrowserOnly: true
});
export const maintenanceUserRightsResource = createResource({
  type: 'maintenanceUserRightsResource',
  getKey: routerContext => {
    var _routerContext$match$3;
    const teamId = (_routerContext$match$3 = routerContext.match.params) === null || _routerContext$match$3 === void 0 ? void 0 : _routerContext$match$3.teamId;
    return `maintenance-user-rights/${teamId !== null && teamId !== void 0 ? teamId : ''}`;
  },
  getData: async routerContext => {
    var _routerContext$match$4;
    const teamId = (_routerContext$match$4 = routerContext.match.params) === null || _routerContext$match$4 === void 0 ? void 0 : _routerContext$match$4.teamId;
    return getMaintenanceUserRights(teamId);
  },
  isBrowserOnly: true
});
export const resources = [...eocCommonResources(), maintenanceResource, maintenanceUserRightsResource];